import { useSnapshot } from 'valtio';

import Loading from '@cartwhl/ui/atoms/Loading';
import Text from '@cartwhl/ui/base/Text';

import { characterPickerStore } from 'stores';

export function UploadIndicator() {
  const { upload } = useSnapshot(characterPickerStore.state);

  if (upload?.status === 'UPLOADING') {
    return (
      <>
        <Text variant="studio/body/medium/md" className="text-gray-45 mr-1">
          Uploading...
        </Text>
        <Loading className="text-green" trackClassName="stroke-gray-30" />
      </>
    );
  }

  if (upload?.status === 'PROCESSING') {
    return (
      <>
        <Text variant="studio/body/medium/sm" className="text-gray-45 mr-1">
          Processing…
        </Text>
        <Loading className="text-green" trackClassName="stroke-gray-30" />
      </>
    );
  }

  if (upload?.status === 'ERROR') {
    return (
      <>
        <Text variant="studio/body/medium/md" className="text-gray-45 mr-1">
          Upload failed
        </Text>
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4917 18.5815C9.31852 18.5815 8.21452 18.3574 7.17969 17.9092C6.14486 17.4665 5.23177 16.8494 4.44043 16.0581C3.65462 15.2668 3.0376 14.3537 2.58936 13.3188C2.14111 12.284 1.91699 11.18 1.91699 10.0068C1.91699 8.83366 2.14111 7.72965 2.58936 6.69482C3.0376 5.65999 3.65462 4.74967 4.44043 3.96387C5.23177 3.17253 6.14209 2.55273 7.17139 2.10449C8.20622 1.65625 9.31022 1.43213 10.4834 1.43213C11.6621 1.43213 12.7689 1.65625 13.8037 2.10449C14.8385 2.55273 15.7516 3.17253 16.543 3.96387C17.3343 4.74967 17.9541 5.65999 18.4023 6.69482C18.8506 7.72965 19.0747 8.83366 19.0747 10.0068C19.0747 11.18 18.8506 12.284 18.4023 13.3188C17.9541 14.3537 17.3343 15.2668 16.543 16.0581C15.7516 16.8494 14.8385 17.4665 13.8037 17.9092C12.7689 18.3574 11.6649 18.5815 10.4917 18.5815ZM10.4917 16.8882C11.4491 16.8882 12.3428 16.7111 13.1729 16.3569C14.0085 16.0028 14.7389 15.5103 15.3643 14.8794C15.9951 14.2485 16.4876 13.5181 16.8418 12.688C17.196 11.8579 17.373 10.9642 17.373 10.0068C17.373 9.05501 17.196 8.16406 16.8418 7.33398C16.4876 6.49837 15.9924 5.76514 15.356 5.13428C14.7251 4.50342 13.9946 4.0109 13.1646 3.65674C12.3345 3.30257 11.4408 3.12549 10.4834 3.12549C9.53158 3.12549 8.63786 3.30257 7.80225 3.65674C6.97217 4.0109 6.24447 4.50342 5.61914 5.13428C4.99382 5.76514 4.50407 6.49837 4.1499 7.33398C3.79574 8.16406 3.61865 9.05501 3.61865 10.0068C3.61865 10.9642 3.79574 11.8579 4.1499 12.688C4.50407 13.5181 4.99382 14.2485 5.61914 14.8794C6.25 15.5103 6.98047 16.0028 7.81055 16.3569C8.64616 16.7111 9.53988 16.8882 10.4917 16.8882ZM10.4917 11.3848C10.0103 11.3848 9.76123 11.1413 9.74463 10.6543L9.62842 6.62012C9.61735 6.37663 9.69206 6.17741 9.85254 6.02246C10.013 5.86751 10.2205 5.79004 10.4751 5.79004C10.7297 5.79004 10.9399 5.87028 11.106 6.03076C11.272 6.18571 11.3494 6.38216 11.3384 6.62012L11.2056 10.6543C11.1945 11.1413 10.9565 11.3848 10.4917 11.3848ZM10.4917 14.1406C10.2205 14.1406 9.98812 14.0549 9.79443 13.8833C9.60628 13.7062 9.51221 13.4876 9.51221 13.2275C9.51221 12.9674 9.60628 12.7516 9.79443 12.5801C9.98812 12.403 10.2205 12.3145 10.4917 12.3145C10.7573 12.3145 10.9842 12.4002 11.1724 12.5718C11.366 12.7433 11.4629 12.9619 11.4629 13.2275C11.4629 13.4932 11.366 13.7118 11.1724 13.8833C10.9787 14.0549 10.7518 14.1406 10.4917 14.1406Z"
            fill="#FF3F56"
          />
        </svg>
      </>
    );
  }

  if (upload?.status === 'SUCCESS') {
    return (
      <>
        <Text variant="studio/body/medium/md" className="text-gray-45 mr-1">
          Uploaded
        </Text>
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4917 18.5815C9.31852 18.5815 8.21452 18.3574 7.17969 17.9092C6.14486 17.4665 5.23177 16.8494 4.44043 16.0581C3.65462 15.2668 3.0376 14.3537 2.58936 13.3188C2.14111 12.284 1.91699 11.18 1.91699 10.0068C1.91699 8.83366 2.14111 7.72965 2.58936 6.69482C3.0376 5.65999 3.65462 4.74967 4.44043 3.96387C5.23177 3.17253 6.14209 2.55273 7.17139 2.10449C8.20622 1.65625 9.31022 1.43213 10.4834 1.43213C11.6621 1.43213 12.7689 1.65625 13.8037 2.10449C14.8385 2.55273 15.7516 3.17253 16.543 3.96387C17.3343 4.74967 17.9541 5.65999 18.4023 6.69482C18.8506 7.72965 19.0747 8.83366 19.0747 10.0068C19.0747 11.18 18.8506 12.284 18.4023 13.3188C17.9541 14.3537 17.3343 15.2668 16.543 16.0581C15.7516 16.8494 14.8385 17.4665 13.8037 17.9092C12.7689 18.3574 11.6649 18.5815 10.4917 18.5815ZM10.4917 16.8882C11.4491 16.8882 12.3428 16.7111 13.1729 16.3569C14.0085 16.0028 14.7389 15.5103 15.3643 14.8794C15.9951 14.2485 16.4876 13.5181 16.8418 12.688C17.196 11.8579 17.373 10.9642 17.373 10.0068C17.373 9.05501 17.196 8.16406 16.8418 7.33398C16.4876 6.49837 15.9924 5.76514 15.356 5.13428C14.7251 4.50342 13.9946 4.0109 13.1646 3.65674C12.3345 3.30257 11.4408 3.12549 10.4834 3.12549C9.53158 3.12549 8.63786 3.30257 7.80225 3.65674C6.97217 4.0109 6.24447 4.50342 5.61914 5.13428C4.99382 5.76514 4.50407 6.49837 4.1499 7.33398C3.79574 8.16406 3.61865 9.05501 3.61865 10.0068C3.61865 10.9642 3.79574 11.8579 4.1499 12.688C4.50407 13.5181 4.99382 14.2485 5.61914 14.8794C6.25 15.5103 6.98047 16.0028 7.81055 16.3569C8.64616 16.7111 9.53988 16.8882 10.4917 16.8882ZM9.59521 13.9497C9.44027 13.9497 9.30192 13.9165 9.18018 13.8501C9.05843 13.7782 8.93945 13.673 8.82324 13.5347L6.86426 11.144C6.72038 10.9614 6.64844 10.776 6.64844 10.5879C6.64844 10.3831 6.71761 10.2088 6.85596 10.0649C6.99984 9.91553 7.17139 9.84082 7.37061 9.84082C7.49788 9.84082 7.61133 9.86849 7.71094 9.92383C7.81608 9.97363 7.91846 10.0649 8.01807 10.1978L9.56201 12.1567L12.8408 6.90234C13.0124 6.62012 13.2282 6.479 13.4883 6.479C13.682 6.479 13.8563 6.54264 14.0112 6.66992C14.1662 6.7972 14.2437 6.96322 14.2437 7.16797C14.2437 7.26204 14.2215 7.35889 14.1772 7.4585C14.1385 7.55257 14.0915 7.64111 14.0361 7.72412L10.3257 13.5264C10.1486 13.8086 9.90511 13.9497 9.59521 13.9497Z"
            fill="#0FD23A"
          />
        </svg>
      </>
    );
  }

  return null;
}
